/**
 * Helps to convert keydown events to "click", eg. on labels connected to checkboxes
 * @param e - keyboard event
 * @param keysToClick - keys to be treated as "click"
 */
export function keydownToClick(e: KeyboardEvent, keysToClick: string[] = ['Enter', 'Space', 'NumpadEnter']) {
	e.preventDefault();

	if (!e.target || e.code && !keysToClick.includes(e.code)) return;

	const targetElement = (e.target as HTMLElement);
	const element = targetElement?.getAttribute('type') !== 'button' ? targetElement.closest('button') : targetElement;
	const htmlElement = element || targetElement

	htmlElement?.previousElementSibling?.dispatchEvent(new MouseEvent('click'));
}
